<template>
  <!-- tabindex is needed to grab the key event -->
  <div class="kd-layout" ref="layout" tabindex="0"
    @keyup="onKeyPress"
    v-click-outside="clickOutsideConfig"
  >
    <vue-draggable-resizable
      v-for="layer in editableLayers"
      :style="{
        backgroundColor: 'rgba(255,255,255,0.4)',
      }"
      :w="percentXToPixels(layer.width) || 10"
      :h="percentYToPixels(layer.height) || 10"
      :x="percentXToPixels(layer.x) || 0"
      :y="percentYToPixels(layer.y) || 0"
      :key="`${layer.id}--draggable`"
      @dragging="(x, y) => { onLayerDrag(x, y, layer.id); }"
      @resizing="onLayerResize"
      :parent="true"
      @activated="onLayerActivate(layer.id)"
      @deactivated="onLayerDeactivate(layer.id)"
      :prevent-deactivation="true"
      :active="ACTIVE_LAYER_ID === layer.id"
    >
    </vue-draggable-resizable>
    <template
      v-for="direction in [directions.TOP, directions.BOTTOM, directions.LEFT, directions.RIGHT]"
    >
      <div
        v-if="EDGE_USES_BLEED(directions.TOP)"
        :key="`layoutBleedLine_${direction}`"
        class="kd-layout__bleed-line"
        :class="[
          `kd-layout__bleed-line--${direction}`,
        ]"
        :style="'--bleed-amount: 3mm'"
      ></div>
    </template>
  </div>
</template>

<script>
import * as log from 'loglevel';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import VueDraggableResizable from 'vue-draggable-resizable';
import directions from '@/shared/directions';

import {
  ACTIVE_SIDE,
  ACTIVE_LAYER_ID,
  BLEED_AMOUNT,
  EDGE_USES_BLEED,
} from '@/store/getter-types';

import {
  SET_ACTIVE_LAYER_BY_ID,
  SET_ACTIVE_LAYER_TO_NONE,
  SET_LAYER_DIMENSIONS,
  SET_ACTIVE_LAYER_BOUNDING_CLIENT_RECT_TO_NONE,
} from '@/store/mutation-types';

import {
  ACTIVATE_LAYER_BY_ID,
  DEACTIVATE_LAYER,
} from '@/store/action-types';

export default {
  data() {
    return {
      cardWidthInPx: 0,
      cardHeightInPx: 0,
      // activeLayerId: '',
      clickOutsideConfig: {
        handler: this.onClickOutside,
        middleware: this.shouldDeactivateLayer,
        events: ['dblclick', 'click', 'touchstart'],
      },
    };
  },
  computed: {
    ...mapGetters([
      ACTIVE_LAYER_ID,
      ACTIVE_SIDE,
      BLEED_AMOUNT,
      EDGE_USES_BLEED,
    ]),
    directions: () => directions,
    editableLayers() {
      if (!this.ACTIVE_SIDE || !this.ACTIVE_SIDE.layers) { return []; }
      const editableLayerTypes = ['foto', 'text', 'url'];
      return this.ACTIVE_SIDE.layers.filter(layer => editableLayerTypes.includes(layer.type));
    },
    // cardWidthInPixels() {

    // },
    // percentToPixel() {

    // },
  },
  methods: {
    ...mapMutations([
      SET_ACTIVE_LAYER_BY_ID,
      SET_ACTIVE_LAYER_TO_NONE,
      SET_LAYER_DIMENSIONS,
      SET_ACTIVE_LAYER_BOUNDING_CLIENT_RECT_TO_NONE,
    ]),
    ...mapActions([
      DEACTIVATE_LAYER,
    ]),
    percentXToPixels(value) {
      // The resizable-draggable library requires integer, therfore we round
      return Math.round(this.cardWidthInPx / 100 * value);
    },
    pixelsToPercentX(value) {
      return value / this.cardWidthInPx * 100;
    },
    percentYToPixels(value) {
      // The resizable-draggable library requires integer, therfore we round
      return Math.round(this.cardHeightInPx / 100 * value);
    },
    pixelsToPercentY(value) {
      return value / this.cardHeightInPx * 100;
    },
    /**
     * Maps from one range to another
     */
    mapRange(value, fromMin, fromMax, toMin, toMax) {
      return (value - fromMin) * (toMax - toMin) / (fromMax - fromMin) + toMin;
    },
    onLayerResize(x, y, width, height) {
      // this.x = x;
      // this.y = y;
      // this.width = width;
      // this.height = height;
      this.SET_LAYER_DIMENSIONS({
        x: this.pixelsToPercentX(x),
        y: this.pixelsToPercentY(y),
        width: this.pixelsToPercentX(width),
        height: this.pixelsToPercentY(height),
      });
    },
    onLayerDrag(x, y, layerId) {
      // this.x = x;
      // this.y = y;
      // Checking if this is the active layer fixes a bug, which can happen
      // when one layer is selected and then, without clicking, another layer is dragged.
      // Then two layer are dragged by mistake. This prevents it.
      if (this.ACTIVE_LAYER_ID === layerId) {
        this.SET_LAYER_DIMENSIONS({
        x: this.pixelsToPercentX(x),
        y: this.pixelsToPercentY(y),
      });
      }
    },
    onLayerActivate(layerId) {
      // we need to wait a bit until we select the layer, because otherwise the
      // buttons "delete" and "duplicate" will not work any more, because there
      // the deselect event will fire after, so there is no selected layer.
      // setTimeout(() => {
      //   this.SET_ACTIVE_LAYER_BY_ID(layerId);
      // }, 50);
      this.SET_ACTIVE_LAYER_BY_ID(layerId);
    },
    onLayerDeactivate(layerId) {
      log.debug('deactivate layer');
      // when selecting a new layer, the selection event is fired before this deselection
      // event is fired, so we cannot undo the new selection.
      if (this.ACTIVE_LAYER_ID === layerId) {
        // if this layer is still the selected one after some time, it means
        // that user clicked outside, possible buttons which depend on the active layer being
        // set have been pressed, and we can therefore deselect the active layer.
        // setTimeout(() => {
        //   if (this.ACTIVE_LAYER_ID === layerId) {
            
        //   }
        // }, 300);
        this.SET_ACTIVE_LAYER_TO_NONE();
      }
    },
    updateCardDimensions() {
      this.$nextTick(() => {
        const el = this.$refs.layout;
        if (el) {
          this.cardWidthInPx = el.clientWidth;
          this.cardHeightInPx = el.clientHeight;
        }
      });
    },
    onKeyPress(ev) {
      const LETTER_ZERO = 49;
      const LETTER_NINE = 57;
      const LETTER_A = 65;
      const LETTER_Z = 90;
      // only show notification when it is [a-Z A-Z 0-9]
      if ((ev.keyCode >= LETTER_A && ev.keyCode <= LETTER_Z)
        || (ev.keyCode >= LETTER_ZERO && ev.keyCode <= LETTER_NINE)) {
        alert('Zum Eingeben von Texten müssen Sie den Layout Modus zuerst verlassen (»Layout speichern« oder »Änderungen verwerfen«)');
      }
    },
    /**
     * Called when there is a selected layer and user clicks outside,
     * deselects active layer then.
     * Uses shouldDeactivateLayer to check if this function is called or click is being
     * ignored (e.g. when clicking on layer settings)
     */
    onClickOutside() {
      log.debug('click outside');
      // if (!this.LAYOUT_MODE_ACTIVE) { return; }
      this.SET_ACTIVE_LAYER_BOUNDING_CLIENT_RECT_TO_NONE();
      this.DEACTIVATE_LAYER();
    },

    /**
     * This check should return false for all classes that
     * should not deactivate the selected layer.
     * For some elements checking the ancestors is also needed.
     */
    shouldDeactivateLayer(event) {
      // add layers here which should NOT result in layer-deselection
      const exceptionsArr = [
        'kd-layout-buttons__button',
      ];
      /* eslint-disable arrow-body-style */
      const containsClassName = exceptionsArr.some((className) => {
        return event.target.classList.contains(className);
      });
      return !containsClassName;
      // const isLayer = this.isAncestorOf(event.target, 'kd-layer');
      // return !(containsClassName || isLayer);
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateCardDimensions);
    this.updateCardDimensions();
  },
  updated() { this.updateCardDimensions(); },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCardDimensions);
  },
  components: {
    VueDraggableResizable,
  },
};
</script>

<style lang="scss">
  .kd-layout {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
  }
  .kd-layout__bleed-line {
    position: absolute;
    --overhang: var(--bleed-amount);

    &--top, &--bottom {
      width: calc(100% + 2 * var(--overhang));
      height: 2px;
      border-bottom: 2px dashed #01A3DE;
    }
    &--left, &--right {
      height: calc(100% + 2 * var(--overhang));
      width: 2px;
      border-left: 2px dashed #01A3DE;
    };
    &--top {
      top: var(--bleed-amount);
      left: -var(--bleed-amount);
    }
    &--bottom {
      bottom: var(--bleed-amount);
      left: -var(--bleed-amount);
    }
    &--left {
      top: -var(--bleed-amount);
      left: var(--bleed-amount);
    }
    &--right {
      top: -var(--bleed-amount);
      right: var(--bleed-amount);
    }
  }
  /*
   * vue-draggable-resizable base code (copied from node_modules because it was not recognized in the production build: 
   * Don't change it (because we might need to update it later, overwrite it down below (see overwrites).
  */
.vdr {
	touch-action: none;
	border: 1px dashed #000
}

.handle,
.vdr {
	position: absolute;
  box-sizing: border-box;

  /*
   * Because of the layer-outline, we need to add another pixel,
   * so the odd numbers are handleSize / 2 +- 1 
   */
}

.handle {
	width: 16px;
	height: 16px;
	background: #eee;
	border: 1px solid #333
}

.handle-tl {
	top: -9px;
	left: -9px;
	cursor: nw-resize
}

.handle-tm {
	top: -9px;
	left: 50%;
	margin-left: -8px;
	cursor: n-resize
}

.handle-tr {
	top: -9px;
	right: -9px;
	cursor: ne-resize
}

.handle-ml {
	left: -9px;
	cursor: w-resize
}

.handle-ml,
.handle-mr {
	top: 50%;
	margin-top: -8px
}

.handle-mr {
	right: -9px;
	cursor: e-resize
}

.handle-bl {
	bottom: -9px;
	left: -9px;
	cursor: sw-resize
}

.handle-bm {
	bottom: -9px;
	left: 50%;
	margin-left: -8px;
	cursor: s-resize
}

.handle-br {
	bottom: -9px;
	right: -9px;
	cursor: se-resize
}

@media (max-width:768px) {
	[class*=handle-]:before {
		content: "";
		left: -9px;
		right: -9px;
		bottom: -9px;
		top: -9px;
		position: absolute
	}
}
  /*
   * vue-draggable-resizable overwrites:
   */
  .handle {
    background-color: #01A3DE;
    border: none;
  }
  .vdr {
    border: 2px dashed #01A3DE;

    &.active, &:hover {
      border: 2px solid #01A3DE;
    }
    &.active {
      z-index: 100 !important;
    }
  }
</style>
